<template>
  <v-row
    no-gutters
    class="align-center py-1 handleDrag element"
    :class="classes"
    :style="{ 'background-color': backgroundColor }"
    @click="isGroup && !isRight ? $emit('toggleHideGroup') : null"
  >
    <v-col v-if="isGroup && !isRight" cols="auto">
      <v-icon>
        {{ isHidden ? 'mdi-menu-right' : 'mdi-menu-down' }}
      </v-icon>
    </v-col>
    <v-col cols="auto" v-if="level > 1 || isRight">
      <layer-style-preview-icon is-icon :layer-type="getLayerType(layer)" :layer-style="layerStyle" />
    </v-col>
    <v-col
      style="min-width: calc(100% - 44px)"
      class="text-left flex-shrink-1 overflow-hidden"
      :class="{ 'pl-2': level > 1 || isRight, 'text--disabled': disabled }"
    >
      <v-row no-gutters class="align-center flex-nowrap" style="gap: 0.5rem">
        <v-col cols="auto" class="text-body-2 flex-shrink-1 overflow-hidden text-truncate">{{ name }}</v-col>
        <v-col v-if="!isGroup && layer?.description" cols="auto" class="d-flex items-center">
          <v-tooltip bottom max-width="500" content-class="tooltip_multiline" color="font">
            <template #activator="{ on }">
              <v-icon v-on="on" small color="primary">
                mdi-help-circle
              </v-icon>
            </template>
            <span>{{ layer?.description }}</span>
          </v-tooltip>
        </v-col>
      </v-row>
      <v-row v-if="(!isGroup || isRight) && dataSourceVerboseName" no-gutters>
        <v-col class="font-weight-light font-italic" style="font-size: 12px; color: rgba(0, 0, 0, 0.59)">
          {{ $i18n.t('admin.datasource') }}: {{ dataSourceVerboseName }}
        </v-col>
      </v-row>
    </v-col>
    <v-spacer />
    <v-col cols="auto">
      <dots-menu
        :disabled="disabled"
        font-size="19px"
        :items="computedDotsItems"
        @manageCard="$emit('manageCard', $props)"
        @changeGroupName="$emit('changeGroupName', $props)"
        @manageLayer="$emit('manageLayer', $props, layer)"
        @copyLayer="$emit('copyLayer', $props, layer)"
        @deleteFromSystem="$emit('deleteFromSystem', $props)"
        @delete="$emit('delete', $props)"
        @changeSymbolization="$emit('changeSymbolization', $props)"
      />
    </v-col>
  </v-row>
</template>

<script>
import { get } from 'vuex-pathify';
import DotsMenu from '@/components/DotsMenu';
import LayerStylePreviewIcon from '@/components/LayerStylePreviewIcon';

import stylePreviewUtilities from '@/mixins/stylePreviewUtilities';

export default {
  name: 'DraggableListsLayersItem',
  mixins: [stylePreviewUtilities],
  components: {
    DotsMenu,
    LayerStylePreviewIcon,
  },
  props: {
    type: {
      type: String,
      default: '',
    },
    id: {
      type: Number,
      required: true,
    },
    name: {
      type: String,
      required: true,
    },
    isRight: {
      type: Boolean,
      default: false,
    },
    level: {
      type: Number,
      required: true,
    },
    isGroup: {
      type: Boolean,
      default: false,
    },
    dotsItems: {
      type: Array,
      default: () => [
        {
          name: 'manageLayer',
        },
        {
          name: 'manageCard',
        },
        {
          name: 'changeSymbolization',
        },
        {
          name: 'copyLayer',
        },
        {
          name: 'deleteFromSystem',
        },
      ],
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    role: {
      type: String,
      default: '',
    },
    isHidden: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    dataSources: get('layers/metadata'),
    dataSourceVerboseName() {
      return this.dataSources[this.layer?.data_source_name]?.verbose_name || '';
    },
    layer() {
      if (this.isGroup) return null;
      return this.$store.get(`layers/layers@${this.id}`);
    },
    layerStyle() {
      if (this.layer) {
        return this.layer.style_web;
      }
      return undefined;
    },
    classes() {
      if (this.isRight) {
        return ['border', 'px-4'];
      }
      return this.level > 1 ? [`px-${this.level * 2}`, 'border'] : [];
    },
    backgroundColor() {
      return this.level > 1 ? 'rgb(231, 231, 231, 0.5)' : 'white';
    },
    computedDotsItems() {
      let dotsItems = JSON.parse(JSON.stringify(this.dotsItems));
      if (this.type === 'service_layer') {
        dotsItems = dotsItems.filter(item => item.name !== 'manageCard');
      }
      if (this.role) {
        dotsItems = dotsItems.filter(item => item.name !== 'deleteFromSystem');
      }
      if (!this.layer?.geometry_type) {
        dotsItems = dotsItems.filter(item => item.name !== 'changeSymbolization');
      }
      return dotsItems;
    },
  },
};
</script>

<style scoped lang="scss">
.border {
  margin-bottom: 4px;
  @include border();
}
</style>
